import { API, graphqlOperation } from "aws-amplify"
import { useState, useEffect } from "react"
import * as customSubscriptions from "../customGraphql/subscriptions"

export const useProgress = ({ projectId, accountId }) => {
  //console.log("useProgress", projectId, accountId)

  const [importedProject, setImportedProject] = useState({
    id: projectId,
    projectId: projectId,
    accountId: accountId,
    importStatus: "",
    parts: 0,
    chapters: 0,
  })

  // TODO(PH-2931): stg backend historically emitted onUpdateImportedProjects
  // instead of onUpdateImportBc3 (branched via isStg helper, removed in this PR).
  // Verify a BC3 import on stg fires next() before merge, or unify the stg backend.
  // See https://github.com/planhopper/planhopper-app/pull/151#discussion_r3720718487
  const query = customSubscriptions.onUpdateImportBc3
  console.log("query", query)

  useEffect(() => {
    const subscription = API.graphql(
      graphqlOperation(query, { id: projectId }),
    ).subscribe({
      next: ({ provider, value }) => {
        setImportedProject(value.data.onUpdateImportBc3)
      },
      error: error => console.warn(error),
    })
    console.log("subscription", subscription)
    return () => {
      subscription.unsubscribe()
    }
  }, [])
  return importedProject
}
